export const validateNumericPassword = (password: string, minLength: number, maxLength?: number) => {
  if (!/^\d+$/.test(password)) return false
  if (maxLength === undefined) maxLength = minLength
  if (password.length < minLength || password.length > maxLength) return false
  return !hasRepeatedNumbers(password) && !isSequencialPassword(password)
}

const hasRepeatedNumbers = (password: string) => {
  const hashTable: Record<string, number> = {}
  for (let i = 0; i < password.length; i++) {
    const char = password[i]
    if (!hashTable[char]) {
      hashTable[char] = 1
      continue
    }
    hashTable[char]++
  }
  const repeatedNumbers = Object.keys(hashTable).length
  const maxRep = Math.floor(password.length / 2)
  return maxRep >= repeatedNumbers
}

function isIncreasingSequence (numbers: number[]) {
  const maxRep = Math.floor(numbers.length / 2)
  let prevNumber = numbers[0]
  let count = 0
  for (let i = 1; i < numbers.length; i++) {
    const number = numbers[i]
    if (number - 1 === prevNumber) count++
    prevNumber = number
  }
  return count >= maxRep
}

function isDecreasingSequence (numbers: number[]) {
  const maxRep = Math.floor(numbers.length / 2)
  let prevNumber = numbers[numbers.length - 1]
  let count = 0
  for (let i = numbers.length - 2; i >= 0; i--) {
    const number = numbers[i]
    if (number - 1 === prevNumber) count++
    prevNumber = number
  }
  return count >= maxRep
}

const isSequencialPassword = (password: string) => {
  const passwordArr = password.split('').map((char) => Number(char))
  return isIncreasingSequence(passwordArr) || isDecreasingSequence(passwordArr)
}
